import { AvatarImage } from 'src/shared/design-system/Avatar';
import { ButtonColors, ButtonSizes, PrimaryButton } from 'src/shared/design-system/Buttons';
import { Card } from 'src/shared/design-system/Card';
import { Chip } from 'src/shared/design-system/Chip';
import { DynamicImage } from 'src/shared/design-system/DynamicImage';
import { Header1 } from 'src/shared/design-system/Headers';
import { BecomeAShef, History, UtensilBowl } from 'src/shared/design-system/Icon';
import { Tabs } from 'src/shared/design-system/Tabs';
import { VerticallyCenteredText } from 'src/shared/design-system/VerticallyCenteredText';
import { ZIndexes } from 'src/shared/ZIndexes';
import styled from 'styled-components';
import { Border, Colors, Font, ScreenWidth, Spacing } from 'web-common/src/shared/styles';

export const OrdersListTitle = styled(Header1)`
  margin-top: ${Spacing.SINGLE};
  font-size: ${Font.Size.XXXL};
  font-weight: ${Font.Weight.BOLD};

  @media (max-width: ${ScreenWidth.SMALL}) {
    font-size: ${Font.Size.XXL};
  }
`;

export const OrdersListTabs = styled(Tabs)`
  position: sticky;
  top: 0;
  background: ${Colors.WHITE};
  z-index: ${ZIndexes.OrderHistoryTabbedNavigator};
`;

export const EmptyOrdersContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  > * {
    margin-top: ${Spacing.SINGLE};
  }

  > :last-child {
    margin-bottom: ${Spacing.QUADRUPLE};
  }
`;

export const OrdersCard = styled(Card)`
  background-color: ${Colors.GRAY_LITE_30};
  margin-top: ${Spacing.THREE_QUARTERS};
  border-radius: ${Border.Radius.M};
`;

export const OrdersCardHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const OrdersCardPriceText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: ${Font.Weight.NORMAL};
  font-size: ${Font.Size.S};
`;

export const OrdersCardBody = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${Colors.GRAY_DARK_20};

  > :not(:last-child) {
    margin-right: ${Spacing.HALF};
  }
`;

export const OrdersCardDishImagePreview = styled(DynamicImage)`
  border-radius: ${Border.Radius.M};
`;

export const OrdersCardBodyRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  > :not(:last-child) {
    margin-right: ${Spacing.HALF};
  }
`;

export const OrdersCardBodyText = styled(VerticallyCenteredText)`
  font-style: ${Font.Family.BODY_SANS};
  font-size: ${Font.Size.XS};

  > a {
    color: ${Colors.ELDERBERRY};
    :hover {
      text-decoration: underline;
    }
  }
`;

export const OrdersCardShefAvatar = styled(AvatarImage)`
  border: 2px solid ${Colors.GRAY_LITE_10};
`;

export const OrdersCardHeaderChip = styled(Chip)`
  font-weight: ${Font.Weight.MEDIUM};
  height: 28px;
`;

export const BecomeAShefIcon = styled(BecomeAShef)`
  width: 24px;
`;

export const UtensilBowlIcon = styled(UtensilBowl)`
  width: 24px;
`;

export const RecurringOrderIcon = styled(History)`
  width: 16px;
  margin-right: 4px;
`;

export const OrdersListRowButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 8px;

  > :not(:first-child) {
    margin-left: ${Spacing.HALF};
  }

  @media (max-width: ${ScreenWidth.SMALL}) {
    width: 100%;
    justify-content: center;

    > :first-child:nth-last-child(2),
    > :first-child:nth-last-child(2) ~ * {
      flex: 1 0 calc(100% / 2);
    }

    > :first-child:nth-last-child(3),
    > :first-child:nth-last-child(3) ~ * {
      flex: 1 0 calc(100% / 3);
    }
  }
`;

export const OrdersListRowButton = styled(PrimaryButton).attrs(() => ({ size: ButtonSizes.S }))`
  font-weight: ${Font.Weight.MEDIUM};
  width: 160px;

  @media (max-width: ${ScreenWidth.SMALL}) {
    width: 100%;
  }
`;

export const OrdersListRowMessageButton = styled(OrdersListRowButton).attrs(() => ({ color: ButtonColors.WHITE }))`
  color: ${Colors.RASPBERRY};
  border: ${Border.Radius.XS} solid ${Colors.RASPBERRY};
`;
